import round from 'lodash/round';
import { func, number } from 'prop-types';
import React from 'react';

import CurrencyInput from '../CurrencyInput';

class ShareInput extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    // eslint-disable-next-line no-param-reassign
    event.target.value /= 100;
    this.props.onChange(event);
  }

  render() {
    return (
      <CurrencyInput
        {...this.props}
        value={round(this.props.value * 100, 2)}
        onChange={this.handleChange}
        prefix="% "
      />
    );
  }
}

ShareInput.propTypes = {
  onChange: func,
  value: number.isRequired,
};

ShareInput.defaultProps = {
  onChange: () => {},
};

export default ShareInput;
